import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { HighlightableText } from '../HighlightableText';
import { ItemDate } from '../ItemDate';

import { TradingListItemTypes } from '.';

export const TradingListItemMobile: React.FC<TradingListItemTypes.Content> = ({
  item,
  isLast,
  operationChanged,
  positionChanged,
  saleQtyChanged,
  purchaseQtyChanged,
  lastUpdatedAt,
}) => {
  const [openAccordion, setOpenAccordion] = React.useState('closed');
  const handlePress = () => {
    setOpenAccordion(openAccordion === 'closed' ? 'opened' : 'closed');
  };
  return (
    <VStack
      paddingX={Spacing['inset.nano']}
      borderBottomColor={Color['neutral.light']}
      borderBottomWidth={isLast ? 0 : 1}>
      <VStack justifyContent="space-between" paddingY={Spacing['inset.xs']}>
        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Text
            justifyContent="space-between"
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Papel
          </Text>
          <Text
            justifyContent="space-between"
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            {item.paper}
          </Text>
        </HStack>
        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Data
          </Text>
          <ItemDate updatedAtDto={item.date} updatedAtDynamic={lastUpdatedAt} />
        </HStack>
        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Qtd. Venda
          </Text>
          <HighlightableText shouldHighlight={saleQtyChanged}>{item.saleQty}</HighlightableText>
        </HStack>
        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Qtd. Compra
          </Text>
          <HighlightableText shouldHighlight={purchaseQtyChanged}>
            {item.purchaseQty}
          </HighlightableText>
        </HStack>
        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Posição
          </Text>
          <HighlightableText shouldHighlight={positionChanged}>{item.position}</HighlightableText>
        </HStack>
        <HStack
          paddingBottom={Spacing['inset.xs']}
          justifyContent="space-between"
          py={Spacing['inset.quarck']}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontSize={Typography['fontsize.md']}
            textAlign="start">
            Operação
          </Text>
          <HighlightableText shouldHighlight={operationChanged}>{item.operation}</HighlightableText>
        </HStack>

        <HStack justifyContent="space-between" py={Spacing['inset.quarck']}>
          <Box />
          <Pressable onPress={handlePress}>
            <HStack maxWidth="100%" flexDir="row">
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                paddingRight={Spacing['inline.nano']}
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.md']}
                color={['brand.tertiary.principal']}
                flex={1}
                textAlign="start">
                DETALHES
              </Text>
              <Icon
                testID="action-icon"
                name={openAccordion === 'opened' ? 'ChevronUp' : 'ChevronDown'}
                size="xxs"
                color={Color['brand.tertiary.principal']}
              />
            </HStack>
          </Pressable>
        </HStack>
      </VStack>

      {openAccordion === 'opened' && (
        <>
          {item?.tradings?.map((itemTrading, index) => (
            <VStack
              marginY={Spacing['inset.nano']}
              key={`${index}`}
              borderRadius="sm"
              marginX={Spacing['inset.nano']}
              paddingX={Spacing['inset.xs']}
              backgroundColor={Color.background}
              paddingY={Spacing['inset.xs']}>
              <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
                <Text fontSize={Typography['fontsize.md']}>Operação</Text>
                <Text fontSize={Typography['fontsize.md']}>{itemTrading.operation}</Text>
              </HStack>
              <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
                <Text fontSize={Typography['fontsize.md']}>Qtd. executadas</Text>
                <Text fontSize={Typography['fontsize.md']}>{itemTrading.executedQty}</Text>
              </HStack>
              <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
                <Text fontSize={Typography['fontsize.md']}>Preço Executado</Text>
                <Text fontSize={Typography['fontsize.md']}>{itemTrading.executedPrice}</Text>
              </HStack>
              <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
                <Text fontSize={Typography['fontsize.md']}>Mercado </Text>
                <Text fontSize={Typography['fontsize.md']}>{itemTrading.market}</Text>
              </HStack>
              <HStack py={Spacing['inset.quarck']} justifyContent="space-between">
                <Text fontSize={Typography['fontsize.md']}>Status </Text>
                <Text fontSize={Typography['fontsize.md']}>{itemTrading.status}</Text>
              </HStack>
            </VStack>
          ))}
        </>
      )}
    </VStack>
  );
};
